import { ModelBase } from '../abstract/model-base.model';
import { Client } from '../client/client.model';
import { User } from '../user/user.model';
import { LegalDocument } from './legal-document.model';

export class LegalConsent extends ModelBase {

    static override CLASS_NAME: string = 'LegalConsent';

    private _document!: LegalDocument;
    private _user!: User;
    private _client!: Client | null;
    private _acceptedAt!: string;

    public get document(): LegalDocument {
        return this._document;
    }

    public set document(value: any) {
        this._setValue('_document', value, 'LegalDocument');
    }

    public get user(): User {
        return this._user;
    }

    public set user(value: any) {
        this._setValue('_user', value, 'User');
    }

    public get client(): Client | null {
        return this._client;
    }

    public set client(value: any) {
        this._setValue('_client', value, 'Client');
    }

    public get acceptedAt(): string {
        return this._acceptedAt;
    }

    public set acceptedAt(value: any) {
        this._setValue('_acceptedAt', value, 'string');
    }
}
